import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import env from "../env";
import { Constants } from "../constants/Constants";

const httpLink = createHttpLink({
	uri: (operation) => {
		const { clientName } = operation.getContext();

		let uri = `${env.REACT_APP_API_BASE_URL}/graphql?${operation.operationName}`;
		if (clientName === Constants.APOLLO_CLIENT_NUGGET_KMS_API_NAME) {
			uri = `${env.REACT_APP_NUGGET_KMS_API_BASE_URL}/api/graphql?${operation.operationName}`;
		}

		return uri;
	},
});

const authLink = setContext((_, { headers }) => {
	// get the authentication token from local storage if it exists
	const token = localStorage.getItem("token");
	// return the headers to the context so httpLink can read them
	return {
		headers: {
			...headers,
			authorization: token ? `Bearer ${token}` : "",
		},
	};
});

const client = new ApolloClient({
	link: ApolloLink.from([authLink, httpLink]),
	cache: new InMemoryCache(),
	defaultOptions: {
		watchQuery: {
			fetchPolicy: "cache-and-network",
		},
		query: {
			fetchPolicy: "network-only",
		},
	},
});

export default client;
